import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import { GraphemeMorphemePanelsContext } from "#grapheme-morpheme-panels-context";
import type { GraphemeMorphemePanelsContextValue } from "#grapheme-morpheme-panels-context-value";

export function GraphemeMorphemePanelsContextProvider({
  children,
  readonlySlice,
  userSlice,
}: PropsWithChildren<GraphemeMorphemePanelsContextValue>) {
  const value = useMemo(() => ({ readonlySlice, userSlice }), [readonlySlice, userSlice]);
  return (
    <GraphemeMorphemePanelsContext.Provider value={value}>
      {children}
    </GraphemeMorphemePanelsContext.Provider>
  );
}
